"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TableManager", {
  enumerable: true,
  get: function get() {
    return _TableManager["default"];
  }
});
exports._validateAndDownloadExperimentFiles = exports.TableManagerRouter = void 0;
Object.defineProperty(exports, "loadExperimentDownloadModule", {
  enumerable: true,
  get: function get() {
    return _ExperimentDownloadModule["default"];
  }
});
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _TableManagerRoute = _interopRequireDefault(require("./TableManagerRoute"));
var _validateAndDownloadExperimentFiles2 = _interopRequireDefault(require("./download/validateAndDownloadExperimentFiles"));
var _TableManager = _interopRequireDefault(require("./TableManager"));
var _ExperimentDownloadModule = _interopRequireDefault(require("./download/ExperimentDownloadModule"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TableManagerRouter = exports.TableManagerRouter = function TableManagerRouter(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
    basename: props.basename
  }, /*#__PURE__*/_react["default"].createElement(_TableManagerRoute["default"], props));
};
TableManagerRouter.propTypes = {
  basename: _propTypes["default"].string
};
TableManagerRouter.defaultProps = {
  basename: ""
};
var _validateAndDownloadExperimentFiles = exports._validateAndDownloadExperimentFiles = function _validateAndDownloadExperimentFiles(host) {
  return function (experimentAccessions) {
    return (0, _validateAndDownloadExperimentFiles2["default"])(host, experimentAccessions, []);
  };
};